import { Directive, ElementRef, HostListener, Input, Optional } from '@angular/core';
import { NgControl } from '@angular/forms';
import DOMPurify from 'dompurify';

@Directive({
  standalone: false,
    selector: 'input:not([noSanitize]), textarea:not([noSanitize])'
})
export class AutoSanitizeDirective {
    @Input() sanitizeOn: 'input' | 'blur' = 'blur';

    constructor(private el: ElementRef, @Optional() private control: NgControl) { }

    @HostListener('blur')
    onBlur() {
        if (this.sanitizeOn === 'blur') {
            this.sanitize();
        }
    }

    @HostListener('input')
    onInput() {
        if (this.sanitizeOn === 'input') {
            this.sanitize();
        }
    }

    /**
     * Opt out (if required some tags in input field)
     * example: <input[(ngModel)]="name" noSanitize/>
     */
    private sanitize() {
        const element: HTMLInputElement | HTMLTextAreaElement = this.el.nativeElement;
        const rawValue = element.value;
        const sanitized = DOMPurify.sanitize(rawValue, { ALLOWED_TAGS: [], ALLOWED_ATTR: [] });
        if (sanitized !== rawValue) {
            element.value = sanitized;
            this.control?.control?.setValue(sanitized, { emitEvent: false });
        }
    }
}
